import { ColumnSetting } from '../../../../../_foundation/models/grid.models';

export const standaloneReadingColumns: ColumnSetting[] = [
  {
    field: 'readingTime',
    title: 'Reading Time',
    filter: 'text',
    filterable: false,
    width: 100
  },
  {
    field: 'actions',
    title: 'Actions',
    width: 80
  }
];



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-manage-readings/components/daily-leg-load-standalone-reading-grid/daily-leg-load-standalone-reading.config.ts